import { userRole as roleTokens } from '@crm/design-tokens';
import type { UserRole } from '@/graphql/generated';

/**
 * Los tokens indexan los roles en minúscula (`admin`) y GraphQL los expone en
 * mayúscula (`ADMIN`). La traducción vive aquí para no repetirla en cada menú.
 */
const KEY: Record<UserRole, keyof typeof roleTokens> = {
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  ASESOR: 'asesor',
  TECNICO: 'tecnico',
  LECTURA: 'lectura',
};

export function roleLabel(role: UserRole): string {
  return roleTokens[KEY[role]]?.label ?? role;
}

export function roleDescription(role: UserRole): string {
  return roleTokens[KEY[role]]?.description ?? '';
}

export function roleIcon(role: UserRole): string {
  return roleTokens[KEY[role]]?.icon ?? 'Circle';
}

export const ALL_ROLES: readonly UserRole[] = ['ADMIN', 'SUPERVISOR', 'ASESOR', 'TECNICO', 'LECTURA'];
